declare var $: any;
declare var window: any;

export class KeeperWeb {
    public constructor() {}

    public checkoutApiWeb(command: string, data: any, config: any) {
        config = {
            ...{
                url: window.keeperPreload.regionalApiEndpoint('us') + '/checkout_api_web',
                method: 'POST',
                dataType: 'JSON',
                contentType: 'application/json',
                isEU: false,
            },
            ...(config || {}),
        };
        if (config.isEU)
            config.url = window.keeperPreload.regionalApiEndpoint('eu') + '/checkout_api_web';

        data = data || {};
        data.command = command;
        config.data = JSON.stringify(data);

        let ajax = $.ajax(config);

        return ajax;
    }

    public rewardApiWeb(config: any) {
        config = {
            ...{
                url: window.keeperPreload.apiEndpoint + '/bi_api/v1/info/pricing/referral_reward',
                method: 'GET',
                dataType: 'JSON',
                contentType: 'application/json',
                isEU: false,
            },
            ...(config || {}),
        };

        let ajax = $.ajax(config);

        return ajax;
    }

    public downloadKeeperSms(data: any, config: any) {
        config = {
            ...{
                url: window.keeperPreload.apiEndpoint + '/download_keeper_sms',
                method: 'POST',
                dataType: 'text',
            },
            ...(config || {}),
        };

        config.data = data || {};

        let ajax = $.ajax(config);

        return ajax;
    }

    public netPromoterScore(data: any, config: any) {
        config = {
            ...{
                url: window.keeperPreload.apiEndpoint + '/net_promoter_score',
                method: 'GET',
                dataType: 'JSON',
                data: data || {},
            },
            ...(config || {}),
        };
        if (config.isEU)
            config.url = (window.keeperPreload.apiEndpoint + '/net_promoter_score').replace(
                '.com',
                '.eu'
            );

        config.data = data || {};

        let ajax = $.ajax(config);

        return ajax;
    }

    public getReferralPromoCode(referralToken: string, config: any) {
        config = {
            ...{
                url: window.keeperPreload.apiEndpoint + '/get_referral_promo_code',
                method: 'POST',
                dataType: 'JSON',
                contentType: 'application/json',
                async: false,
                data: JSON.stringify({referral_token: referralToken}),
                isEU: false,
            },
            ...(config || {}),
        };
        if (config.isEU)
            config.url = (window.keeperPreload.apiEndpoint + '/get_referral_promo_code').replace(
                '.com',
                '.eu'
            );

        let ajax = $.ajax(config);

        return ajax;
    }

    public realSupportContact(data: any, config: any) {
        config = {
            ...{
                url: window.keeperPreload.apiEndpoint + '/realsupportcontact',
                method: 'POST',
                data: data,
            },
            ...(config || {}),
        };

        let ajax = $.ajax(config);

        return ajax;
    }

    public realPress(config: any) {
        config = {
            ...{
                url: window.keeperPreload.apiEndpoint + '/realpress',
                method: 'GET',
            },
            ...(config || {}),
        };

        let ajax = $.ajax(config);

        return ajax;
    }

    public realReviews(config: any) {
        config = {
            ...{
                url:
                    window.keeperPreload.apiEndpoint +
                    '/realreviews/' +
                    window.keeper.getCurrentLocale(),
                method: 'GET',
                dataType: 'JSON',
            },
            ...(config || {}),
        };

        let ajax = $.ajax(config);

        return ajax;
    }

    public leads(data: any, config: any) {
        config = {
            ...{
                url: window.keeperPreload.apiEndpoint + '/leads',
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(data),
            },
            ...(config || {}),
        };

        let ajax = $.ajax(config);

        return ajax;
    }
}
